import { Button, FormControl, FormLabel, HStack, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Spinner, Text } from '@chakra-ui/react';
import React from 'react';
import { useOperation } from '../components/useOperation';

export const RenameTemplateDialog = (props: {
  onClose: () => void;
  templateId: string;
  onRename: (oldId: string, newId: string) => Promise<void>;
}) => {
  // Extract the base name (without PAGE_ prefix and .md suffix)
  const getBaseName = (id: string) => id.replace(/^PAGE_/, '').replace(/\.md$/, '');
  const [baseName, setBaseName] = React.useState(getBaseName(props.templateId));
  const initialRef = React.useRef<HTMLInputElement>(null);

  const [execute, errorMessage, isProcessing] = useOperation(async () => {
    const newId = `PAGE_${baseName.toUpperCase()}.md`;
    await props.onRename(props.templateId, newId);
    props.onClose();
  }, [baseName]);

  return (
    <Modal isOpen onClose={props.onClose} isCentered initialFocusRef={initialRef}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Rename Page Template</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl>
            <FormLabel>New Template Name</FormLabel>
            <Input
              ref={initialRef}
              value={baseName}
              onChange={e => setBaseName(e.target.value.toUpperCase())}
              autoFocus
              maxLength={50}
            />
          </FormControl>
          {errorMessage && <Text color="red.500" mt={2}>{errorMessage}</Text>}
        </ModalBody>
        <ModalFooter>
          <Button onClick={props.onClose} mr={3} variant="outline" isDisabled={isProcessing}>Cancel</Button>
          <Button colorScheme="blue" onClick={execute} isLoading={isProcessing} isDisabled={!baseName || `PAGE_${baseName.toUpperCase()}.md` === props.templateId}>
            <HStack spacing={2}>{isProcessing && <Spinner size="sm" />}<Text>Rename</Text></HStack>
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
